import fetch from 'isomorphic-fetch';
import moment from 'moment';


import { API_ROOT } from '../../api-config';
import { fetch_options } from '../utils';

import { ERROR } from '../user';
import { Competition } from '../../models/competition';

export const CREATE_COMPETITION = 'competitions/CREATE_COMPETITION';
export const LOAD_COMPETITION = 'competitions/LOAD_COMPETITION';
export const RECEIVED_COMPETITIONS = 'competitions/RECEIVED_COMPETITIONS';
export const RECEIVED_COMPETITION = 'competitions/RECEIVED_COMPETITION';
export const RESET_CURRENT = 'competitions/RESET_CURRENT';
export const DELETED_COMPETITION = 'competitions/DELETED_COMPETITION';
export const RECEIVED_NEW_STATUS = 'competitions/RECEIVED_NEW_STATUS';
export const RECEIVED_NEW_EXERCISE = 'competitions/RECEIVED_NEW_EXERCISE';
export const RECEIVED_PARTICIPANT = 'competitions/RECEIVED_PARTICIPANT';

export const COMPETITION_STATUS = { INIT: 'init', OPENED: 'opened', STARTED: 'started', PLAYING: 'playing', FINISHED: 'finished', };
export const MAXEXERCISESECONDS = 30;

const initialState = {
  current: null,
  data: null,
  isFetching: false,
  lastUpdated: null,
  error: null
};

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case CREATE_COMPETITION:
      return {
        ...state,
        current: null,
        isFetching: true
      };

    case LOAD_COMPETITION:
      return {
        ...state,
        current: null,
        isFetching: true
      };

    case RECEIVED_COMPETITIONS:
      return {
        ...state,
        isFetching: false,
        current: null,
        data: action.competitions,
        lastUpdated: moment()
      };

    case RECEIVED_COMPETITION:
      const competitionIndex = state.data ? state.data.findIndex((c: Competition) => c.id === action.aCompetition.id) : -1;
      const updatedData = state.data ? [...state.data] : [];
      if (competitionIndex >= 0) {
        updatedData[competitionIndex] = action.aCompetition;
      } else updatedData.push(action.aCompetition);
      updatedData.sort((a: Competition, b: Competition) => b.id - a.id);
      return {
        ...state,
        isFetching: false,
        current: action.aCompetition,
        data: updatedData,
        lastUpdated: moment()
      };

    case RESET_CURRENT:
      return {
        ...state,
        current: null,
        isFetching: false
      };

    case DELETED_COMPETITION:
      const filteredData = state.data ? state.data.filter((c: Competition) => c.id !== action.cid) : null;
      return {
        ...state,
        isFetching: false,
        current: null,
        data: filteredData,
        lastUpdated: moment()
      };


    case RECEIVED_NEW_STATUS:
      console.log('RECEIVED_NEW_STATUS action:', action,'status:', state.current);

      return {
        ...state,
        isFetching: false,
        current: state.current ? { ...state.current, status: action.newStatus } : null,
        lastUpdated: moment()
      };

    case RECEIVED_NEW_EXERCISE:
      // console.log('RECEIVED_NEW_EXERCISE action:', action,'status:', state.current);
      
      return {
        ...state,
        isFetching: false,
        current: state.current ? { ...state.current, currentExercise: action.newCurrentExercise, startedTime: action.newStartedTime } : null,
        lastUpdated: moment()
      };

    case RECEIVED_PARTICIPANT:
      const currentParticipants = state.current && state.current.participants ? state.current.participants : [];
      const foundIndex = currentParticipants.findIndex(aP => aP.uid == action.participant.uid);

      if (foundIndex < 0) currentParticipants.push(action.participant);
      else currentParticipants[foundIndex] = action.participant;

      const updatedCurrent = state.current ? { ...state.current, participants: currentParticipants } : null;

      return {
        ...state,
        isFetching: false,
        current: updatedCurrent,
        lastUpdated: moment()
      };

    default:
      return state;
  }
};

export function loadUserCompetitions(uid: number) {

  return function (dispatch) {
    dispatch({
      type: LOAD_COMPETITION
    });

    const url = `${API_ROOT}/competitions/findbyuser/${uid}`;

    return fetch(url, fetch_options)
      .then(response => {
        if (response.ok) return response.json();
        else if (response.status == 404) return null;
        else throw new Error(response);
      })
      .then(competitions => {
        // console.log('loadUserCompetitions received:', competitions);

        dispatch({
          type: RECEIVED_COMPETITIONS,
          competitions: competitions,
          receivedAt: Date.now()
        });

      })
      .catch(error => {
        console.error('loadUserCompetitions error fetching:', error);
        dispatch({
          type: ERROR,
          error: 'An error ocurred'
        });
      });
  };
}

export function loadStudentCompetitions(teacherId: number, classId: number) {

  return function (dispatch) {
    dispatch({
      type: LOAD_COMPETITION
    });

    const url = `${API_ROOT}/competitions/findbystudent/${teacherId}/${classId}`;

    return fetch(url, fetch_options)
      .then(response => {
        if (response.ok) return response.json();
        else if (response.status == 404) return null;
        else throw new Error(response);
      })
      .then(competitions => {
        // console.log('loadUserCompetitions received:', competitions);

        dispatch({
          type: RECEIVED_COMPETITIONS,
          competitions: competitions,
          receivedAt: Date.now()
        });

      })
      .catch(error => {
        console.error('loadUserCompetitions error fetching:', error);
        dispatch({
          type: ERROR,
          error: 'An error ocurred'
        });
      });
  };
}

export function createCompetition(aCompetition: Competition) {

  return function (dispatch) {
    dispatch({
      type: CREATE_COMPETITION
    });

    const url = `${API_ROOT}/competitions`;
    const _fetch_options = {
      ...fetch_options,
      method: "POST",
      body: JSON.stringify(aCompetition)
    };

    return fetch(url, _fetch_options)
      .then(response => {
        if (response.ok) return response.json();
        else throw new Error(response);
      })
      .then(aCompetition => {
        // console.log('createCompetition received:', aCompetition);

        dispatch({
          type: RECEIVED_COMPETITION,
          aCompetition: aCompetition,
          receivedAt: Date.now()
        });

      })
      .catch(error => {
        console.error('createCompetition error fetching:', error);
        dispatch({
          type: ERROR,
          error: 'An error ocurred'
        });
      });
  };
}

export function loadCompetition(competitionId: number) {

  return function (dispatch) {
    dispatch({
      type: LOAD_COMPETITION
    });

    const url = `${API_ROOT}/competitions/${competitionId}`;
    return fetch(url, fetch_options)
      .then(response => {
        if (response.ok) return response.json();
        else throw new Error(response);
      })
      .then(aCompetition => {
        // console.log('loadCompetition received:', aCompetition);
        const _aCompetition = aCompetition.data.attributes;
        _aCompetition['id'] = aCompetition.data.id;

        dispatch({
          type: RECEIVED_COMPETITION,
          aCompetition: _aCompetition,
          receivedAt: Date.now()
        });

      })
      .catch(error => {
        console.error('loadCompetition error fetching:', error);
        dispatch({
          type: ERROR,
          error: 'An error ocurred'
        });
      });
  };
}

export const resetCurrentCompetition = () => {
  return dispatch => {
    dispatch({
      type: RESET_CURRENT
    });
  };
};

export function deleteUserCompetition(uid: number, cid: number) {

  return function (dispatch) {
    dispatch({
      type: LOAD_COMPETITION
    });

    const url = `${API_ROOT}/competitions/delete/${uid}/${cid}`;

    const _fetch_options = {
      ...fetch_options,
      method: "DELETE",
    };

    return fetch(url, _fetch_options)
      .then(response => {
        if (response.ok) return response.json();
        else throw new Error(response);
      })
      .then(response => {
        // console.log('deleteUserCompetition received:', response);

        dispatch({
          type: DELETED_COMPETITION,
          cid: cid,
        });

      })
      .catch(error => {
        console.error('deleteUserCompetition error fetching:', error);
        dispatch({
          type: ERROR,
          error: 'An error ocurred'
        });
      });
  };
}

export function updateCompetitionFields(fields) {
  return (dispatch, getState) => {

    const storeState = getState();

    const _competition: any = storeState.competition.current;
    // console.log('updateCompetitionFields fields:', _competition, '::', fields);

    const diff_fields = {};
    if (_competition) for (let prop in fields) {
      if (JSON.stringify(_competition[prop]) != JSON.stringify(fields[prop])) diff_fields[prop] = fields[prop];
    }

    // console.log('updateCompetitionFields diff_fields:', diff_fields);

    if (_competition && Object.keys(diff_fields).length > 0) {

      dispatch({
        type: LOAD_COMPETITION
      });

      const id = _competition.id;

      const _fetch_options = {
        ...fetch_options,
        method: "PUT",
        body: JSON.stringify({ ...diff_fields })
      };
      const url = `${API_ROOT}/competitions/fields/${id}`;

      return fetch(url, _fetch_options)
        .then(response => {
          if (response.status != 200) throw new Error(response.status);
          else return response.json();
        })
        .then(aCompetition => {
          console.log('updateCompetitionFields fetched:', aCompetition);

          dispatch({
            type: RECEIVED_COMPETITION,
            aCompetition: aCompetition,
            receivedAt: Date.now()
          });

        })
        .catch(error => {
          console.error('updateCompetitionFields - Error fetching:', error);
        });

    }

  };
}

export function sendCompetitionResponse(competitionId, exerciseId, aResponse) {
  return (dispatch, getState) => {

    dispatch({
      type: LOAD_COMPETITION
    });


    const _fetch_options = {
      ...fetch_options,
      method: "PUT",
    };

    if (aResponse) {
      _fetch_options['body'] = JSON.stringify(aResponse);
    }

    const url = `${API_ROOT}/competitions/${competitionId}/responses/${exerciseId}`;

    return fetch(url, _fetch_options)
      .then(response => {
        if (response.status != 200) throw new Error(response.status);
        else return response.json();
      })
      .then(aCompetition => {
        // console.log('sendCompetitionResponse fetched:', aCompetition);

        dispatch({
          type: RECEIVED_COMPETITION,
          aCompetition: aCompetition,
          receivedAt: Date.now()
        });

      })
      .catch(error => {
        console.error('sendCompetitionResponse - Error fetching:', error);
      });

  };
}

export function addStudentToCompetition(competitionId, studentData) {
  return (dispatch, getState) => {

    // console.log('addStudentToCompetition studentData:', studentData, 'competitionId:', competitionId);

    dispatch({
      type: LOAD_COMPETITION
    });


    const _fetch_options = {
      ...fetch_options,
      method: "PUT",
    };

    if (studentData) {
      _fetch_options['body'] = JSON.stringify(studentData);
    }

    const url = `${API_ROOT}/competitions/${competitionId}/addstudent`;

    return fetch(url, _fetch_options)
      .then(response => {
        if (response.status != 200) throw new Error(response.status);
        else return response.json();
      })
      .then(aCompetition => {
        // console.log('addStudentToCompetition fetched:', aCompetition);

        dispatch({
          type: RECEIVED_COMPETITION,
          aCompetition: aCompetition,
          receivedAt: Date.now()
        });

      })
      .catch(error => {
        console.error('addStudentToCompetition - Error fetching:', error);
      });

  };
}